import { ShieldCheck, Headphones, Wrench, ArrowRight } from "lucide-react";
import { SectionHead, FadeIn } from "./Reveal";

const BG_IMG =
  "https://images.unsplash.com/photo-1486006920555-c77dcf18193c?q=80&w=1280&auto=format&fit=crop";

const POINTS = [
  {
    n: "01",
    icon: ShieldCheck,
    title: "Czysty montaż",
    desc: "Zero widocznych kabli i chałturzenia — fabryczna estetyka, tylko brzmi o klasę lepiej.",
  },
  {
    n: "02",
    icon: Headphones,
    title: "Doradztwo w doborze sprzętu",
    desc: "Pomożemy dobrać wzmacniacz i głośniki pod Twoje brzmienie i budżet — bez ściemy i zaniżania parametrów.",
  },
  {
    n: "03",
    icon: Wrench,
    title: "Indywidualne podejście",
    desc: "Każdy projekt traktujemy osobno: od pomiarów bagażnika po ostatnią korektę DSP.",
  },
];

export default function WhyUs() {
  return (
    <section
      id="dlaczego"
      className="relative overflow-hidden py-24 md:py-36"
      data-testid="whyus-section"
    >
      <div className="absolute inset-0" aria-hidden="true">
        <img
          src={BG_IMG}
          alt=""
          loading="lazy"
          className="h-full w-full object-cover opacity-15"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/70 to-ink" />
      </div>

      <div className="relative mx-auto grid max-w-7xl gap-16 px-6 md:px-10 lg:grid-cols-2">
        <div className="lg:sticky lg:top-32 self-start">
          <SectionHead
            eyebrow="Dlaczego my"
            title={
              <>
                Robimy to, <br />
                <span className="text-brand">na co się umówiliśmy</span>
              </>
            }
            desc="Nie demo w wideo i nie obiecanki na pół roku. Konkretny montaż, konkretny dźwięk, konkretny termin."
          />
          <FadeIn delay={0.15}>
            <a
              href="#kontakt"
              data-testid="whyus-cta"
              className="mt-10 inline-flex items-center gap-3 rounded-full border border-white/25 px-8 py-4 text-xs font-bold uppercase tracking-[0.15em] text-white transition-all duration-300 hover:border-brand hover:text-brand"
            >
              Porozmawiajmy o Twoim aucie
              <ArrowRight size={16} />
            </a>
          </FadeIn>
        </div>

        <div className="flex flex-col">
          {POINTS.map((p, i) => (
            <FadeIn key={p.n} delay={i * 0.1}>
              <div
                data-testid={`whyus-item-${i}`}
                className="group flex gap-6 md:gap-10 border-t border-white/10 py-10 md:py-12 transition-colors duration-500 last:border-b hover:bg-white/[0.03]"
              >
                <span className="font-display text-5xl md:text-6xl font-semibold leading-none text-outline transition-all duration-500 group-hover:text-brand group-hover:[-webkit-text-stroke:0px]">
                  {p.n}
                </span>
                <div>
                  <p.icon
                    size={22}
                    className="mb-4 text-brand"
                    strokeWidth={1.75}
                  />
                  <h3 className="font-display text-2xl md:text-3xl font-semibold uppercase tracking-tight text-white">
                    {p.title}
                  </h3>
                  <p className="mt-3 max-w-md text-sm md:text-base leading-relaxed text-zinc-400">
                    {p.desc}
                  </p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
